import { EVENT_KEYNAMES as e } from "../../common/constants/index.js";
import { getUniqueString as t } from "../../common/utils/index.js";
import { t as n } from "../../_plugin-vue_export-helper-BTgDAbhb.js";
import r from "../../common/mixins/keyboard-list-navigation.js";
import { t as i } from "../../mode_constants-tb7TL85q.js";
import { LIST_ITEM_NAVIGATION_TYPES as a } from "../list-item/list-item-constants.js";
import { POPOVER_APPEND_TO_VALUES as o } from "../popover/popover-constants.js";
import s from "../popover/popover.js";
import { DROPDOWN_PADDING_CLASSES as c } from "./dropdown-constants.js";
import { createBlock as l, createElementVNode as u, mergeProps as d, normalizeClass as f, openBlock as p, renderSlot as m, resolveComponent as h, toHandlers as g, withCtx as _ } from "vue";
//#region components/dropdown/dropdown.vue
var v = {
	compatConfig: { MODE: 3 },
	name: "DtDropdown",
	components: { DtPopover: s },
	mixins: [r({
		indexKey: "highlightIndex",
		idKey: "highlightId",
		listElementKey: "getListElement",
		listItemRole: "menuitem",
		afterHighlightMethod: "afterHighlight",
		beginningOfListMethod: "beginningOfListMethod",
		endOfListMethod: "endOfListMethod",
		activeItemKey: "activeItemEl",
		focusOnKeyboardNavigation: !0
	})],
	inheritAttrs: !1,
	props: {
		contentMode: i,
		open: {
			type: [Boolean, null],
			default: null
		},
		openOnContext: {
			type: Boolean,
			default: !1
		},
		padding: {
			type: String,
			default: "small",
			validator: (e) => Object.keys(c).some((t) => t === e)
		},
		modal: {
			type: Boolean,
			default: !0
		},
		contentWidth: {
			type: String,
			default: null
		},
		maxHeight: {
			type: String,
			default: ""
		},
		maxWidth: {
			type: String,
			default: ""
		},
		listId: {
			type: String,
			default() {
				return t();
			}
		},
		navigationType: {
			type: String,
			default: a.ARROW_KEYS,
			validator: (e) => Object.values(a).includes(e)
		},
		fallbackPlacements: {
			type: Array,
			default: () => ["auto"]
		},
		placement: {
			type: String,
			default: "bottom"
		},
		onBeginningOfList: {
			type: Function,
			default: null
		},
		onEndOfList: {
			type: Function,
			default: null
		},
		listClass: {
			type: [
				String,
				Array,
				Object
			],
			default: ""
		},
		footerClass: {
			type: [
				String,
				Array,
				Object
			],
			default: ""
		},
		appendTo: {
			type: [HTMLElement, String],
			default: "body",
			validator: (e) => o.includes(e) || e instanceof HTMLElement
		},
		tether: {
			type: Boolean,
			default: !0
		},
		transition: {
			type: String,
			default: "fade"
		}
	},
	emits: [
		"keydown",
		"highlight",
		"update:open",
		"opened"
	],
	data() {
		return {
			LIST_ITEM_NAVIGATION_TYPES: a,
			DROPDOWN_PADDING_CLASSES: c,
			EVENT_KEYNAMES: e,
			openedWithKeyboard: !1,
			isOpen: null
		};
	},
	computed: {
		dropdownListeners() {
			return {
				"update:open": (e) => {
					this.$emit("update:open", e);
				},
				opened: (e) => {
					this.updateInitialHighlightIndex(e);
				},
				keydown: (t) => {
					switch (t.code) {
						case e.up:
						case e.arrowup:
							this.onUpKeyPress(t), t.stopPropagation(), t.preventDefault();
							break;
						case e.down:
						case e.arrowdown:
							this.onDownKeyPress(t), t.stopPropagation(), t.preventDefault();
							break;
						case e.space:
						case e.spacebar:
							this.onSpaceKey();
							break;
						case e.enter:
							this.onEnterKey();
							break;
						case e.home:
							this.onHomeKeyPress(t), t.stopPropagation(), t.preventDefault();
							break;
						case e.end:
							this.onEndKeyPress(t), t.stopPropagation(), t.preventDefault();
							break;
						default:
							this.onKeyPress(t);
							break;
					}
					this.$emit("keydown", t);
				}
			};
		},
		beginningOfListMethod() {
			return this.onBeginningOfList || this.jumpToEnd;
		},
		endOfListMethod() {
			return this.onEndOfList || this.jumpToBeginning;
		},
		activeItemEl() {
			return this.getListElement().querySelector("#" + this.highlightId);
		},
		isArrowKeyNav() {
			return this.navigationType === this.LIST_ITEM_NAVIGATION_TYPES.ARROW_KEYS;
		},
		listClasses() {
			return [
				"d-dropdown-list",
				c[this.padding],
				this.listClass,
				{ "d-context-menu-list": this.openOnContext }
			];
		},
		shouldOpenWithArrowKeys() {
			return !this.openOnContext;
		}
	},
	methods: {
		onMouseHighlight(e) {
			let t = e.target.closest("li");
			t && t.role && this.highlightId !== t.id && (this.setHighlightId(t.id), t.focus());
		},
		getListElement() {
			return this.$refs.listWrapper;
		},
		clearHighlightIndex() {
			this.setHighlightIndex(-1);
		},
		afterHighlight() {
			this.highlightIndex !== this._itemsLength() - 1 && this.$emit("highlight", this.highlightIndex);
		},
		updateInitialHighlightIndex(e) {
			this.isOpen = e, e ? (this.openedWithKeyboard && this.isArrowKeyNav && this.setHighlightIndex(0), this.$emit("opened", !0)) : (this.clearHighlightIndex(), this.openedWithKeyboard = !1, this.$emit("opened", !1));
		},
		onSpaceKey() {
			this.open || (this.openedWithKeyboard = !0);
		},
		onEnterKey() {
			this.open || (this.openedWithKeyboard = !0);
		},
		onUpKeyPress() {
			if (!this.isOpen) {
				this.openedWithKeyboard = !0;
				return;
			}
			if (this.isArrowKeyNav) return this.onUpKey();
		},
		onDownKeyPress() {
			if (!this.isOpen) {
				this.openedWithKeyboard = !0;
				return;
			}
			if (this.isArrowKeyNav) return this.onDownKey();
		},
		onHomeKeyPress() {
			if (!(!this.isOpen || !this.isArrowKeyNav)) return this.onHomeKey();
		},
		onEndKeyPress() {
			if (!(!this.isOpen || !this.isArrowKeyNav)) return this.onEndKey();
		},
		onKeyPress(e) {
			if (!(!this.isOpen || !this.isArrowKeyNav || !this.isValidLetter(e.key))) return e.stopPropagation(), e.preventDefault(), this.onNavigationKey(e.key);
		}
	}
}, y = ["id"];
function b(e, t, n, r, i, a) {
	let o = h("dt-popover");
	return p(), l(o, d({
		ref: "popover",
		"content-width": n.contentWidth,
		"content-mode": n.contentMode,
		open: n.open,
		placement: n.placement,
		"initial-focus-element": i.openedWithKeyboard ? "first" : "dialog",
		"fallback-placements": n.fallbackPlacements,
		padding: "none",
		role: "menu",
		"append-to": n.appendTo,
		modal: n.modal,
		"max-height": n.maxHeight,
		"max-width": n.maxWidth,
		"open-with-arrow-keys": a.shouldOpenWithArrowKeys,
		"open-on-context": n.openOnContext
	}, e.$attrs, {
		tether: n.tether,
		transition: n.transition,
		"footer-class": n.footerClass
	}, g(a.dropdownListeners)), {
		anchor: _(({ attrs: t }) => [m(e.$slots, "anchor", d({ ref: "anchor" }, t))]),
		content: _(({ close: r }) => [u("ul", {
			id: n.listId,
			ref: "listWrapper",
			class: f(a.listClasses),
			"data-qa": "dt-dropdown-list-wrapper",
			onMouseleave: t[0] || (t[0] = (...e) => a.clearHighlightIndex && a.clearHighlightIndex(...e)),
			onMousemoveCapture: t[1] || (t[1] = (...e) => a.onMouseHighlight && a.onMouseHighlight(...e))
		}, [m(e.$slots, "list", { close: r })], 42, y)]),
		footerContent: _(({ close: t }) => [m(e.$slots, "footer", { close: t })]),
		_: 3
	}, 16, [
		"content-width",
		"content-mode",
		"open",
		"placement",
		"initial-focus-element",
		"fallback-placements",
		"append-to",
		"modal",
		"max-height",
		"max-width",
		"open-with-arrow-keys",
		"open-on-context",
		"tether",
		"transition",
		"footer-class"
	]);
}
var x = /* @__PURE__ */ n(v, [["render", b]]);
//#endregion
export { x as default };

//# sourceMappingURL=dropdown.js.map